<template>
  <div class="layout">
    <HeadMenu />
    <router-view />
    <FooterSection />
  </div>
</template>
<script>
import HeadMenu from "./HeadMenu.vue";
import FooterSection from "./FooterSection.vue";
export default {
  name: "LayoutComponent",
  components: {
    HeadMenu,
    FooterSection,
  },
};
</script>
